/** URL生成 */
export const generatePath = (path: string, pathParam?: string) => {
  if (pathParam) {
    return path.replace(':id', pathParam)
  } else {
    return path
  }
}
